import moment from 'moment';

const getDisabledDates = (
  availableUnitsData,
  initialStartingDate
) => {
  const availableUnitsPerDate = availableUnitsData
    ? availableUnitsData.rentalItems[0].availableUnitsPerDate
    : [];

  return availableUnitsPerDate
    .filter(item => {
      if (initialStartingDate && item.date) {
        if (initialStartingDate.startDate && initialStartingDate.endDate) {
          if (
            moment(item.date, 'YYYY-MM-DD').isBetween(
              initialStartingDate.startDate,
              initialStartingDate.endDate,
              'day',
              '[]'
            )
          ) {
            return false;
          }
        }
        if (
          moment(initialStartingDate).isSame(moment(item.date, 'YYYY-MM-DD'))
        ) {
          return false;
        }
      }
      if (!item.availableUnits) {
        let isDisabled = true;

      
        return isDisabled;
      }
      return !item.availableUnits;
    })
    .map(item => item.date);
};



const getDisabledDatesWithTime = (
  availableUnitsData,
  initialStartingDate
) => {
  const availableUnitsPerDate = availableUnitsData
    ? availableUnitsData.rentalItems[0].availableUnitsPerDate
    : [];

  const availabilityByDate = {};
  
  availableUnitsPerDate.forEach(item => {
    if (!availabilityByDate[item.date]) {
      availabilityByDate[item.date] = [];
    }
    availabilityByDate[item.date].push(item.availableUnits);
  });

  const disabledDates = Object.keys(availabilityByDate)
    .filter(date => {
      const allTimeSlotsUnavailable = availabilityByDate[date].every(units => units === 0);
      
      if (!allTimeSlotsUnavailable) {
        return false;
      }

      
      if (initialStartingDate) {
        if (typeof initialStartingDate === 'object' && initialStartingDate.startDate && initialStartingDate.endDate) {
          if (
            moment(date, 'YYYY-MM-DD').isBetween(
              initialStartingDate.startDate,
              initialStartingDate.endDate,
              'day',
              '[]'
            )
          ) {
            return false; 
          }
        } else {
          if (moment(initialStartingDate).isSame(moment(date, 'YYYY-MM-DD'), 'day')) {
            return false; 
          }
        }
      }

      return true;
    });

  return disabledDates;
};

export {
  getDisabledDates,
  getDisabledDatesWithTime
};